import { LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';

export class SuspendCompanyConfirmationWebComponent extends LitElement {
  @property({ type: Number, reflect: true })
  activeCompaniesCount;

  @property({ type: Number, reflect: true })
  activePartnerCompaniesCount;

  @query('#suspend-recursive-toggle')
  recursiveToggle: GzCheckboxWebComponent;

  public translateFn: (string) => string;

  protected render() {
    return html`
      <div>
        <gz-text id="suspend-company-info-text" fontSize=${FontSizes.HEADING_6} fontWeight=${FontWeights.NORMAL}>
          ${this.activeCompaniesCount === 1
            ? this.translateFn(
                "The company's users will no longer be able to log in and its managed endpoints will no longer be protected."
              )
            : this.translateFn(
                "The companies' users will no longer be able to log in and their managed endpoints will no longer be protected."
              )}
        </gz-text>

        ${this.activePartnerCompaniesCount > 0
          ? html` <gz-checkbox
                label="${this.translateFn('Suspend all companies under this company as well.')}"
                id="suspend-recursive-toggle"
              >
              </gz-checkbox>
              <gz-text fontSize=${FontSizes.PARAGRAPH_12} class="suspend-recursive-text helper-text"
                >${this.translateFn('This option will apply recursively.')}
              </gz-text>`
          : ''}
      </div>
    `;
  }

  static get styles() {
    return styles;
  }
}
